import {createAction} from 'redux-actions';
import axios from 'axios';
import {apiUrl, loginServiceUrl, redirectUri, accountServiceUrl, productAbbreviation} from './config';

export const ACCOUNT_LIST           = 'ACCOUNT_LIST'
export const ACCOUNT_TOTAL          = 'ACCOUNT_TOTAL'
export const ACCOUNT_CREATE         = 'ACCOUNT_CREATE';
export const ACCOUNT_UPDATE         = 'ACCOUNT_UPDATE';
export const SUB_ACCOUNT_LIST       = 'SUB_ACCOUNT_LIST';
export const ACCOUNT_SHOW           = 'ACCOUNT_SHOW'
export const ACCOUNT_SUSPEND        = 'ACCOUNT_SUSPEND'
export const ACCOUNT_RESUME_SUSPEND = 'ACCOUNT_RESUME_SUSPEND'
export const ACCOUNT_DELETE         = 'ACCOUNT_DELETE'
export const ACCOUNT_AGGREGATE      = 'ACCOUNT_AGGREGATE'
export const SUB_ACCOUNT_UPDATE     = 'SUB_ACCOUNT_UPDATE'
export const LOGIN_SERVICE          = 'LOGIN_SERVICE'
export const EDIT_LOGIN_SERVICE     = 'EDIT_LOGIN_SERVICE'
export const ACCOUNT_INQURE         = 'ACCOUNT_INQURE'
export const ACCOUNT_ANSWER         = 'ACCOUNT_ANSWER'
export const ACCOUNT_SELECT         = 'ACCOUNT_SELECT'

export const accountList = createAction(ACCOUNT_LIST, (user_id) => {
  return axios.get(apiUrl + 'client/accounts')
    .then(function(res) {
      return res.data.data
    })
});

export const accountTotal = createAction(ACCOUNT_TOTAL, () => {
  return axios.get(apiUrl + 'client/accounts/total')
    .then(function(res) {
      return res.data.data
    })
});

export const accountCreate = createAction(ACCOUNT_CREATE, (data) => {
  return axios.post(apiUrl + 'client/accounts', {body: data})
    .then(function(res) {
      return res.data.data
    })
});

export const accountUpdate = createAction(ACCOUNT_UPDATE, (id, data) => {
  return axios.patch(apiUrl + 'client/accounts/' + id, data)
    .then(function(res) {
      return res.data.data
    })
});


export const accountDelete = createAction(ACCOUNT_DELETE, (id) => {
  return axios.delete(apiUrl + 'client/accounts/' + id)
    .then(function(res) {
      return {id: id}
    })
});

export const subAccountList = createAction(SUB_ACCOUNT_LIST, (account_id) => {
  return axios.get(apiUrl + `client/accounts/${account_id}/sub_accounts`)
    .then(function(res) {
      return {
        id: account_id,
        sub_accounts: res.data.data
      }
    })
});

export const accountShow = createAction(ACCOUNT_SHOW, (id) => {
  return axios.get(apiUrl + 'client/accounts/' + id)
    .then(function(res) {
      return res.data.data
    })
});

export const accountSuspend = createAction(ACCOUNT_SUSPEND, (id) => {
  return axios.post(apiUrl + `client/accounts/${id}/suspend`)
    .then(function(res) {
      return {id: id, is_suspended: true}
    })
});

export const accountResumeSuspend = createAction(ACCOUNT_RESUME_SUSPEND, (id, model) => {
  return axios.delete(apiUrl + `client/accounts/${id}/suspend`, {data: model})
    .then(function(res) {
      return res.data.data
    })
});

export const accountAggregate = createAction(ACCOUNT_AGGREGATE, (ids) => {
  return axios.patch(apiUrl + 'client/accounts/aggregate', {account_ids:  ids})
    .then(function(res) {
      return res.data.data
    })
});

export const subAccountUpdate = createAction(SUB_ACCOUNT_UPDATE, (id, subId, model) => {
  return axios.patch(apiUrl + `client/accounts/${id}/sub_accounts/${subId}`, model)
    .then(function(res) {
      return {
        id: id,
        sub_accounts: [res.data.data]
      }
    })
});

export const loginService = createAction(LOGIN_SERVICE, (providerName, serviceId, email) => {
  const returnUrl = `${redirectUri}/bank`
  const redirectPath = `/auth/${providerName}?product_abbreviation=${productAbbreviation}&service_id=${serviceId}&return_url=${returnUrl}`
  const url = `${loginServiceUrl}?redirect_path=${encodeURIComponent(redirectPath)}&mail=${encodeURIComponent(email)}`

  window.location.href = url
});

export const editLoginService = createAction(EDIT_LOGIN_SERVICE, (serviceId, identifiableCode, email) => {
  const returnUrl = `${redirectUri}/bank`
  let redirectPath = `/accounts/${identifiableCode}/edit`
  redirectPath = `${redirectPath}?account_id=${encodeURIComponent(identifiableCode)}&service_id=${serviceId}&return_url=${encodeURIComponent(returnUrl)}&product_abbreviation=${productAbbreviation}`

  const url = `${accountServiceUrl}mfid/login?redirect_path=${encodeURIComponent(redirectPath)}&mail=${encodeURIComponent(email)}`
  window.location.href = url
});

export const accountInquire = createAction(ACCOUNT_INQURE, (id, model) => {
  return axios.get(apiUrl + `client/accounts/${id}/additional_credentials/inquire`)
    .then(function(res) {
      return {
        id: id,
        additional_credentials: res.data.data.additional_credentials
      }
    })
});

export const accountAnswer = createAction(ACCOUNT_ANSWER, (id, model) => {
  return axios.patch(apiUrl + `client/accounts/${id}/additional_credentials/answer`, {additional_credentials: model})
    .then(function(res) {
      return {
        id: id,
        additional_credentials: res.data.data.additional_credentials
      }
    })
});

export const accountSelect = createAction(ACCOUNT_SELECT, (accountId, isScrollTo, delayHighlightTime) => {
  return {
    accountId: accountId,
    isScrollTo: isScrollTo || false,
    delayHighlightTime: delayHighlightTime || 1000
  }
});

